import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';
import i18next from 'i18next';
import LanguageIcon from '@mui/icons-material/Language';
export default function BasicSelect() {

    const { i18n } = useTranslation();
    let lng = i18next.language;
    // const theme = useTheme();

    const toggleLanguage = () => {
        const otherLng = lng === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(otherLng);
    };


    return (
        <Button onClick={toggleLanguage} sx={{ border: `1px solid rgba(197, 197, 197, 1)`, backgroundColor: 'transparent', px: '10px', py: 0.5 }} >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'row-reverse' }} >
                <LanguageIcon sx={{ color: '#000' }} />
                <Typography color={'nav.link'} fontWeight={'bold'} >{lng === 'en' ? 'العربية' : 'English'}</Typography>
            </Box>
        </Button>
    );
}